export const mainConfig = {
  sumsub: {
    initialize: 'https://static.sumsub.com/idensic/static/sns-websdk-builder.js',
    personalLevel: 'basic-kyc-level',
    companyLevel: 'corp-kyc-level',
  },
};
